export default {
  list: { lazy: () => import('./OrderingOrders'), component: 'OrderingOrderList' },
  options: {
    list: {
      title: 'Orders List',
      breadCrumb: 'Orders List',
    },
  },
}
